import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {VideoGridElement} from '../../_shared/videos-grid/video-grid-element.model';

@Component({
  selector: 'app-homeownersexemption',
  templateUrl: './homeownersexemption.component.html',
  styleUrls: ['./homeownersexemption.component.scss']
})

export class HomeownersexemptionComponent {

  id: number;
  videos: VideoGridElement[] = [
    {
      url: 'https://www.youtube.com/embed/RWvuJaZkbrc?list=PL99qj8Q3_1psopvHemZMeUntqzEw7-m5a',
      title: 'Presentation 3: Homeowners\' Exemption with Frank Diaz, Jr.',
      powerpoint: null
    }
  ];

  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }

}
